import { ReactKit } from '@team/react';
import { Entry as Root } from './entry';
import { RegisterContentInset } from './components/register-content-inset';
import { Context } from './context';

const AppRoot = ReactKit.createCompoundComponent(Root, {
  RegisterContentInset,
});

AppRoot.displayName = 'AppRoot';
AppRoot.RegisterContentInset.displayName = 'AppRootRegisterContentInset';
Context.displayName = 'AppRootContext';

export { AppRoot };
export { Context as AppRootContext };

export { Mode as AppRootMode } from './enums';

export type {
  Props as AppRootProps,
  SafeAreaInsets as AppRootSafeAreaInsets,
} from './types';
